import { create } from 'zustand';

export const useReconciliationStore = create((set, get) => ({
  selectedTransaction: undefined,
  transactions: [],
  suggestions: [],
  loading: false,
  setSelectedTransaction: (id) => {
    const tx = get().transactions.find(t => t.id === id);
    set({ selectedTransaction: tx });
  },
  setTransactions: (txs) => set({ transactions: txs }),
  setSuggestions: (sugs) => set({ suggestions: sugs }),
  setLoading: (loading) => set({ loading }),
}));
